export enum Role {
    Admin = 'Admin',
    Manager = 'Manager',
    Interviewer = 'Interviewer',
    Recruiter = 'Recruiter',
}